import {defineStyle, defineStyleConfig} from '@chakra-ui/react'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import size from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const baseStyle = defineStyle({
  borderRadius: borders.radii.full,
  paddingLeft: spacing['5xs'],
  paddingRight: spacing['5xs'],
  color: 'white',
})

const subtleNeutral = defineStyle({
  bg: colors.background.tertiary,
  color: colors.text.secondary,
})

const solidNeutral = defineStyle({
  bg: colors.background.contrast,
})

const subtleDiscovery = defineStyle({
  bg: colors.background['discovery-secondary'],
  color: colors.text.discovery,
})

const solidDiscovery = defineStyle({
  bg: colors.background.discovery,
})

const subtleInfo = defineStyle({
  bg: colors.background['info-secondary'],
  color: colors.text.info,
})

const solidInfo = defineStyle({
  bg: colors.background.info,
})

const subtleSuccess = defineStyle({
  bg: colors.background['success-secondary'],
  color: colors.text.success,
})

const solidSuccess = defineStyle({
  bg: colors.background.success,
})

const subtleWarning = defineStyle({
  bg: colors.background['warning-secondary'],
  color: colors.text.warning,
})

const solidWarning = defineStyle({
  bg: colors.background.warning,
})

const subtleDestructive = defineStyle({
  bg: colors.background['error-secondary'],
  color: colors.text.error,
})

const solidDestructive = defineStyle({
  bg: colors.background.error,
})

const sm = defineStyle({
  maxHeight: size['3xs'],
  minHeight: size['3xs'],
  minWidth: size['3xs'],
  ...typography.textStyles.body.small,
})

const md = defineStyle({
  maxHeight: size['2xs'],
  minHeight: size['2xs'],
  minWidth: size['2xs'],
  ...typography.textStyles.body.medium,
})

const lg = defineStyle({
  maxHeight: size.xs,
  minHeight: size.xs,
  minWidth: size.xs,
  ...typography.textStyles.body.large,
})

const badgeTheme = defineStyleConfig({
  baseStyle,
  sizes: {sm, md, lg},
  variants: {
    subtleNeutral,
    solidNeutral,
    subtleDiscovery,
    solidDiscovery,
    subtleInfo,
    solidInfo,
    subtleSuccess,
    solidSuccess,
    subtleWarning,
    solidWarning,
    subtleDestructive,
    solidDestructive,
  },
  defaultProps: {
    size: 'sm',
    variant: 'subtleNeutral',
  },
})

export default badgeTheme
